(function() {
	'use strict';
	var $ = avm.require('cash');


    var $boxButtonToggler = $('.button-us-toggler'),
        $box1 = $('.actionboxUS [data-us-box="box1"]'),
        $box2 = $('.actionboxUS [data-us-box="box2"]'),
        $detailsToggle = $('.js-toggle-details')

    $boxButtonToggler.on('click', function() {
        $(this).siblings($boxButtonToggler).removeClass('selected');

        if($(this).hasClass('js-box1')) {
            $(this).parent().parent().siblings($box2).removeClass('d-block').addClass('d-none');
            $(this).parent().parent().siblings($box1).removeClass('d-none').addClass('d-block');
        }
        if($(this).hasClass('js-box2')) {
            $(this).parent().parent().siblings($box1).removeClass('d-block').addClass('d-none');
            $(this).parent().parent().siblings($box2).removeClass('d-none').addClass('d-block');
        }
        $(this).addClass('selected');
	});

    $detailsToggle.on('click', function(e) {
        e.preventDefault();

        var $detailsContent = $(this).parent().prev('.actionboxUS-details');

            if($detailsContent.hasClass('d-none')) {
                $(this).find('.show').removeClass('d-inline-flex').addClass('d-none');
                $(this).find('.hide').removeClass('d-none').addClass('d-inline-flex');
                $detailsContent.removeClass('d-none')
            } else {
                $(this).find('.hide').removeClass('d-inline-flex').addClass('d-none');
                $(this).find('.show').removeClass('d-none').addClass('d-inline-flex');
                $detailsContent.addClass('d-none')
            }

	});


})()
